<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center mb-2">
        <span class="col-auto">
          <h2 class="mb-0">
            Open PO's
            <jni-spinner *ngIf="showLoader"></jni-spinner>
          </h2>
        </span>

        <span
          class="col-auto d-flex justify-content-between gap-2 align-items-center">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <p-button
            label="Add New Vendor"
            variant="outlined"
            icon="pi pi-plus"
            severity="secondary"
            (click)="onVendorRedirection()"
            class="fullwdth secondary-btn" />

          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="25"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="openPoListings"
          [(selection)]="selectedVendors"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="false"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          [paginator]="true"
          [rows]="20"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th>PO #</th>
              <th>Status</th>
              <th>Vendor Name</th>
              <th>Total PO Amount</th>
              <th>Total Unmatched Amount</th>
              <th>Total PO Qty</th>
              <th>Total Merch</th>
              <th>Total Freight</th>
              <th>Total Tax</th>
              <th>Date Created</th>
              <th>In Hands Date</th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="poNumber"
                    id="poNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'poNumber',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="status"
                    id="status"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'status',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="vendorName"
                    id="vendorName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'vendorName',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-vendorListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="vendorListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  [disabled]="false"
                  [value]="vendorListing"
                  (click)="checkboxSelection()"></p-tableCheckbox>
              </td>
              <td (click)="getCurrentVendor(vendorListing.poNumber)">
                <a class="link">{{ vendorListing.poNumber }}</a>
              </td>
              <td>
                {{ vendorListing.status }}
              </td>
              <td>
                {{ vendorListing.vendorName }}
              </td>
              <td>
                {{ vendorListing.totalPOAmount | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.totalUnmatchedAmount | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.totalPOQty | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.totalMerch | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.totalFreight | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.totalTax | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.dateCreated | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ vendorListing.inhandsDate | date: "MM-dd-yyyy" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No open po found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
